<!-- Header Section -->
<mat-card-title
  mat-dialog-title
  class="d-flex align-items-center mb-1"
  style="gap: 0.5rem"
>
  <mat-icon class="mr-1">sticky_note_2</mat-icon>
  {{ title }}
</mat-card-title>

<mat-card-subtitle class="mb-1"> {{ subtitle }} </mat-card-subtitle>
<mat-divider></mat-divider>

<!-- Scrollable Content Section -->
<mat-dialog-content>
  <form [formGroup]="documentUploadFormGroup" *ngIf="firstFieldName">
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>{{ firstFieldName }}</mat-label>
      <input type="text" matInput formControlName="firstField" />
      <mat-error
        *ngIf="documentUploadFormGroup.controls.firstField.hasError('required')"
      >
        {{ firstFieldName }} is required
      </mat-error>
    </mat-form-field>
    <mat-form-field
      appearance="fill"
      style="width: 100%"
      *ngIf="secondFieldName"
      class="mt-0"
    >
      <mat-label>{{ secondFieldName }}</mat-label>
      <input type="text" matInput formControlName="secondField" />
      <mat-error
        *ngIf="
          documentUploadFormGroup.controls.secondField.hasError('required')
        "
      >
        {{ secondFieldName }} is required
      </mat-error>
    </mat-form-field>
  </form>
  <div [ngClass]="firstFieldName ? 'mt-0' : 'mt-4'">
    <app-drag-and-drop
      *ngIf="documentsDataList?.length < attachmentLimit"
      [allowUpload]="true"
      [allowDelete]="false"
      [uploadDirectly]="false"
      [displayImg]="true"
      (triggerFileSelected)="triggerFileSelected($event)"
      [showUploadedFiles]="false"
      [allowedTypesNames]="data.allowedTypesNames"
      [allowedTypesRegex]="data.allowedTypesRegex"
      [maxSize]="data.maxSize"
      [remainingFilesCount]="100"
      [remainingFiles]="false"
      required
    >
    </app-drag-and-drop>

    <app-display-data-in-dlt
      *ngIf="documentsDataList?.length > 0"
      [dataListArray]="documentsDataList"
      (onClickAction)="action($event)"
      [totalCount]="documentsDataList.length"
    >
    </app-display-data-in-dlt>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-flat-button
    color="accent"
    (click)="onSave()"
    [disabled]="
      documentsDataList.length === 0 || documentUploadFormGroup.invalid
    "
  >
    Save
  </button>
</mat-dialog-actions>
